import { Form } from '~/shared/api'
import {
  checkedRule,
  emailRule,
  emptyRule,
  minLengthCountRule,
  phoneRule,
  requiredRule
} from '~/shared/utils/validation'

export default class WomenAPKForm extends Form {
  readonly contest = 'womans_apk'
  name: string = ''
  address: { id: number | string; name: string } | null = null
  dateOfBirth: string = ''
  phone: string = ''
  email: string = ''
  education: string = ''
  placeOfWork: string = ''
  text: string = ''
  isConsentGiven: boolean = false
  documents: Array<string> = []

  toInputData() {
    return {
      contest: this.contest,
      data: {
        personal: {
          name: this.name,
          region: this.address?.name || '',
          date_of_birth: this.dateOfBirth,
          phone: this.phone,
          email: this.email,
          education: this.education,
          place_of_work: this.placeOfWork
        },
        task: {
          text: this.text
        },
        agreements: {
          personal: this.isConsentGiven,
          documents: this.documents
        }
      }
    }
  }

  static rules() {
    return {
      name: requiredRule,
      address: requiredRule,
      dateOfBirth: requiredRule,
      phone: { ...requiredRule, ...phoneRule },
      email: { ...requiredRule, ...emailRule },
      education: emptyRule,
      placeOfWork: emptyRule,
      text: { ...requiredRule, ...minLengthCountRule(500) },
      isConsentGiven: checkedRule
    }
  }
}
